import React from "react";
import { motion } from "framer-motion";
import { FadeIn } from "../atoms/FadeIn";
import { SectionFrame } from "../atoms/SectionFrame";
import { AnimatedText } from "../atoms/AnimatedText";
import { AssetPlaceholder } from "../atoms/AssetPlaceholder";
import { Magnet } from "../atoms/Magnet";
import { ASSETS } from "../../lib/assets";
import { TID } from "../../lib/testIds";

export function AboutSection() {
    const grid = ASSETS.aboutGrid;
    return (
        <SectionFrame innerClassName="min-h-screen">
            <div className="relative min-h-screen flex items-center justify-center overflow-hidden py-24 md:py-32 px-6 md:px-12">
                {/* Floating grid behind */}
                <div className="absolute inset-0 pointer-events-none">
                    {grid.map((g, i) => {
                        const positions = [
                            "left-[5%] top-[10%] w-24 h-24 md:w-32 md:h-32",
                            "right-[7%] top-[14%] w-28 h-28 md:w-36 md:h-36",
                            "left-[10%] bottom-[12%] w-32 h-24 md:w-44 md:h-32",
                            "right-[4%] bottom-[4%] w-20 h-24 md:w-24 md:h-28",
                            "left-[42%] top-[6%] w-20 h-20 md:w-28 md:h-28 hidden md:block",
                            "right-[36%] bottom-[1%] w-28 h-28 md:w-36 md:h-36 hidden md:block",
                        ];
                        return (
                            <div key={g.caption} className={`absolute pointer-events-auto ${positions[i]}`}>
                                <Magnet padding={80} strength={10} className="w-full h-full block">
                                    <motion.div
                                        animate={{ y: [0, -8, 0] }}
                                        transition={{
                                            duration: 5 + i * 0.6,
                                            repeat: Infinity,
                                            ease: "easeInOut",
                                            delay: i * 0.3,
                                        }}
                                        className="w-full h-full"
                                    >
                                        <AssetPlaceholder
                                            caption={g.caption}
                                            className="w-full h-full"
                                            rounded="rounded-[18px] md:rounded-[24px]"
                                        />
                                    </motion.div>
                                </Magnet>
                            </div>
                        );
                    })}
                </div>

                <div className="relative z-10 max-w-[820px] text-center">
                    <FadeIn y={40}>
                        <h2
                            data-testid={TID.aboutHeading}
                            className="display-text font-black uppercase"
                            style={{
                                fontSize: "clamp(2.5rem, 9vw, 7rem)",
                                lineHeight: 1,
                                letterSpacing: "-0.03em",
                            }}
                        >
                            We&apos;re GrowCo<br />Motion.
                        </h2>
                    </FadeIn>
                    <div className="mt-10 md:mt-14">
                        <AnimatedText
                            data-testid={TID.aboutParagraph}
                            className="font-medium mx-auto"
                            style={{
                                color: "var(--text)",
                                fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
                                maxWidth: "780px",
                                lineHeight: 1.45,
                            }}
                        >
                            A motion design studio from India helping ambitious businesses communicate through strategy, storytelling and animation.
                        </AnimatedText>
                    </div>
                </div>
            </div>
        </SectionFrame>
    );
}
